var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmoji = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 22a10 10 0 100-20 10 10 0 000 20zM8 11a2 2 0 100-4 2 2 0 000 4zm10-2a2 2 0 11-4 0 2 2 0 014 0zm.83 6c-.58 2.83-3.83 5-6.83 5s-6.25-2.17-6.92-5c-.08-.58.34-1 .92-1h12c.58 0 1 .42.83 1z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmoji);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/emoji.def020a23223c97f483841c26571c5f0.svg";